import React from 'react';

import { ManageOrders } from 'features/orders';

export const TechOperatorPayinOrdersPage: React.FC = () => <ManageOrders />;
